export const WELCOME_DISCLAIMER_MODAL_ID = 'WELCOME_DISCLAIMER_MODAL_ID';

// eolsUserHistory rows are course-scoped via courseSectionId. For non-course-scoped
// records (account-wide T&C acceptance), we use a sentinel value.
export const NON_COURSE_SCOPED_SECTION_ID = 0;
